import { CASES } from './constants';

export const updateTemplates = (payload) => {
    return { type: CASES.UPDATE_TEMPLATES, payload };
};

export const updateTemplatesForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_TEMPLATES_FORM,
        payload: { key, data },
    };
};

export const clearTemplates = () => {
    return { type: CASES.CLEAR_TEMPLATES, payload: {} };
};
